module.exports = __webpack_public_path__ + "../resources/img/ic_check_line.72b2828e.svg";